import React, { useRef } from 'react';
import { Camera } from 'lucide-react';
import { ReactComponent as ImageAvatar } from './assets/image-avatar.svg';
import { cn } from 'utils/helpers';

type Props = {
  profileImage: string | null;
  setProfileImage: (image: string) => void;
};

const ProfileImageAvatar: React.FC<Props> = ({
  profileImage,
  setProfileImage,
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFileSelect = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    if (!file.type.startsWith('image/')) {
      console.error('Select an image');
      return;
    }

    const reader = new FileReader();
    reader.onloadend = () => {
      setProfileImage(reader.result as string);
    };
    reader.onerror = () => {
      console.error('Error reading file');
    };
    reader.readAsDataURL(file);
  };

  return (
    <div
      className={cn(
        'relative p-5 rounded-full bg-[#32395E] flex items-center justify-center',
        profileImage && 'p-0',
      )}
      onClick={handleFileSelect}
    >
      {profileImage ? (
        <img
          src={profileImage}
          alt="Profile"
          className="w-[5.625rem] h-[5.625rem] rounded-full"
        />
      ) : (
        <ImageAvatar className="text-[#D7C0FB] w-[3.125rem] h-[3.125rem]" />
      )}
      <div className="absolute bottom-0 right-0 flex items-center justify-center bg-[#6000E9] rounded-full p-1">
        <Camera className="text-white w-[1rem] h-[1rem] fill-white" />
        <div className=" mt-[0.1rem] absolute w-[0.3rem] h-[0.3rem] bg-[#6000E9] rounded-full"></div>
      </div>
      <input
        type="file"
        accept="image/*"
        onChange={handleFileChange}
        ref={fileInputRef}
        className="hidden"
      />
    </div>
  );
};

export default ProfileImageAvatar;
